import React, { useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { Link, useNavigate } from "react-router-dom";

import { deleteAttendance } from "../../../../../MyApi/hr/attendances";


import icons from "../../../../../Data/icons";
import classes from "../../../../../assets/css/dropdown.module.css"

const SingleAttendance = ({ attend, refetch }) => {
  const {
    id,
    employe,
    check_in_type,
    check_out_type,
    in_branch,
    out_branch,
    in_time,
    out_time,
    late_time,
    work_hour,
    break_time,
    over_time,
    date,
    company,
  } = attend;
  const [showDrop ,setShowDrop] = useState(false)
  const navigate = useNavigate();
  const EditPen = icons.pen;
  const mutation = useMutation(
    ["deleteAttendance", id],
    () => deleteAttendance(id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.data.response.message}`);
      },
    }
  );

  const deletePost = () => {
    mutation.mutate();
  };

  return (
    <tr>
      <td>
        <b>{date}</b>
        <br></br>
        {employe}
      </td>
      <td>
        <div class="text-success">
          <i className="fa  fa-map-marker"></i> {in_time} <br></br> {in_branch}
        </div>
      </td>
      <td>
        <div class="text-danger">
          <i className="fa fa-sign-out"></i> {out_time} <br></br> {out_branch}
        </div>
      </td>
      <td>{late_time}</td>
      <td>
        <div class="text-success">
          <i className="fa fa-clock-o"></i> {work_hour}
        </div>
        <div class="text-warning">
          <i className="fa fa-coffee"></i> {break_time}
        </div>
      </td>
      <td className="d-print-none">
        <div>
     
          <div >
            <button
              onClick={()=>{setShowDrop(!showDrop)}}
              className="btn btn-primary dropdown-toggle"
              type="button"
          
             >
            </button>
       {showDrop &&     <ul className={classes.dropDownMenu} >
              <li >
                <Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/attendances/${id}`}>
                <i class="fa fa-eye"></i>
                عرض
                </Link>
              </li>
              <li>
                <Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/currency/${id}`}>
                <EditPen />
                تعديل
                </Link>
              </li>
              <li>
                <button class="dropdown-item" onClick={deletePost}>
                <i class="fa fa-trash"></i>
                حذف
                </button>
              </li>
            </ul>}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default SingleAttendance;
